module.exports = __webpack_public_path__ + "static/media/continue-icon.f0855e45.svg";